<template>
    <div class="card">
        <div class="card-header white">
            <a class="nav-link text-green" id="w1-tab1" data-toggle="tab" >Front Page Notification</a>        
        </div>
        <div class="card-body no-p">
            <div class="row p-3">
                <div class="col-md-12">
                    <form>
                        <div class="form-row">
                            <div class="col-md-12 mb-3">
                                <input type="text" class="form-control" id="validationDefault03" placeholder="Subject" required>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12 mb-3">
                                <textarea type="text" class="form-control" id="validationDefault03" placeholder="Message" required></textarea>
                            </div>
                        </div>
                        <div class="form-row">
                            <div class="col-md-12 mb-3">
                                <div class="form-row">
                                    <div class="col-md-12 mb-3">
                                        <select class="custom-select select2" required>
                                            <option value="">Message Option</option>
                                            <option value="1">Enable</option>
                                            <option value="2">Disable</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <button class="btn btn-success" type="submit"><i class="icon-arrow_forward mr-2"></i>Send</button>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    
}
</script>